import { Component, OnDestroy, OnInit, ViewChild , HostListener} from '@angular/core';
import { NbMediaBreakpointsService, NbDialogService, NbMenuService, 
  NbSidebarService, NbThemeService, NbGlobalPosition, NbToastrService, NbPopoverDirective} from '@nebular/theme';
 

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {AuthService}  from '../../../shared/services/auth.service';
import {SaleService}  from '../../../shared/services/sale.service';
import {PaymentModalComponent}  from '../../../shared/components/payment-modal/payment-modal.component';

import {IdeaModalComponent}  from '../../../shared/components/idea-modal/idea-modal.component';
import {BuyTariffModalComponent}  from '../../../shared/components/buy-tariff-modal/buy-tariff-modal.component';
import {  Router} from '@angular/router';




@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();

  private menu$:any;
  userPictureOnly: boolean = true;
  //user: any = {};

  themes = [
    {
      value: 'default',
      name: 'Світла',
    },
    {
      value: 'dark',
      name: 'Темна',
    } 
  ];

  // Sales figures for the header. Loaded once per page load: this is a summary of
  // completed bookings, not something that ticks.
  salesSummary:any = null

  currentTheme = 'dark';
  isThemeDark:boolean = true 
  sidebarOpened:boolean = false

  userMenu = [  { command: 'profile', title: 'Профіль'},  {  command: 'group', title: 'Новини та оновлення' },   
  {  command: 'idea', title: 'Запропонувати ідею' },  
   {  command: 'exit', title: 'Вийти' } ];


/*  paymentMenu = [  { command: 'pay', title: 'Пополнить счет'},  {  command: 'costs', title: 'Расходы' },
	 {  command: 'income', title: 'Доходы', classes:'disabled' } ];*/


 @HostListener('window:click', ['$event']) 
 windowClickEvent($event: MouseEvent) {
    
    
    
    
   // console.log($event)
     
            
                if(this.sidebarOpened === true ){
                    // @ts-ignore: Unreachable code error
                	if(!$event.target.closest('.sidebar-toggle') && !$event.target.closest('.menu-sidebar ')   ){
                              this.toggleSidebar()
                       }
              }
                
    
  }
  
  
  
 @HostListener('document:touchend', ['$event'])
 windowClickEvent2($event: MouseEvent) {
    
    
    
    
   // console.log($event)
     
            
                if(this.sidebarOpened === true ){
                    // @ts-ignore: Unreachable code error
                	if(!$event.target.closest('.sidebar-toggle') && !$event.target.closest('.menu-sidebar ')   ){
                              this.toggleSidebar()
                       }
              }
                
    
  }


  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
     private dialogService: NbDialogService,
	      public authService : AuthService,
	      public saleService : SaleService, 
 		 private router: Router,
    	private toastrService: NbToastrService,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService) {
              
              
		 
		let theme = localStorage.getItem('theme') || 'default';
             this.changeTheme(theme)
	    if(theme !== 'dark'){

		this.isThemeDark = false
	    }
	  
  }


  toggleTheme(){
     // this.isThemeDark = !this.isThemeDark
      
      if(this.isThemeDark){
        this.changeTheme('default')
      }else{
        this.changeTheme('dark')
      }
  }

  changeThemeLightFlag(){

    if(this.currentTheme === 'dark'){
      this.isThemeDark = true
    } else {
      this.isThemeDark = false
    }

  }


  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.changeThemeLightFlag()

    this.authService.loadRetentionStatus().subscribe(()=>{}, ()=>{})

    // Sales figures. A failure here must not take the header down with it - the
    // header is on every page, and an author with no sales yet is the normal case.
    this.saleService.getSalesSummary().subscribe((data:any)=>{
      if(data && data.ok){ this.salesSummary = data }
    }, ()=>{})

    if(this.authService?.userData?.channelUrl){

	this.userMenu.unshift({command: 'channel', title: 'Мій канал'})


//isThemeDark

	}

	let themeLabel = 'Темна тема '+ (this.isThemeDark ? 'on' : 'off')

	this.userMenu.splice(this.userMenu.length -3 ,0, {command: 'changeTheme', title:themeLabel });


    this.menu$ = this.menuService.onItemClick() 
      .subscribe(({item}:any) => {

//
 	/*	if(item.command === 'pay'){
		  	this.openPayModal()
			return
		} else
		if(item.command === 'costs'){
		 	this.router.navigate(['/expenses'])
			return
		} else 

		if(item.command === 'income'){
		 
			return
		} else*/

		if(item.command === 'exit'){
		   this.authService.logout()
			this.router.navigate(['/login'])
			return
		} else
		if(item.command === 'profile'){
		  
			this.router.navigate(['/profile'])
			return
		}  else
		if(item.command === 'channel'){
		  	            
			window.open(`/channel/${this.authService.userData.channelUrl}`, "_blank"); 

			//this.router.navigate(['/channel', this.authService.userData.channelUrl])
			return
		}  else
		
		if(item.command === 'idea'){
		  	            
			
			this.openIdeaModal()
			
			return
		}  else if(item.command === 'changeTheme'){

			this.toggleTheme()
			item.title = 'Темна тема '+ (this.isThemeDark ? 'on' : 'off')
		}
 
 	
	});


	 
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        localStorage.setItem('theme',themeName)
        this.currentTheme = themeName;
        this.changeThemeLightFlag()
      });
  }



 goTo(to){
	
    this.router.navigate([to])

 }

 openPayModal(){

 this.dialogService.open(PaymentModalComponent, {
			       
			      context: { 
			      },

					
			     closeOnEsc: false,
				closeOnBackdropClick: false
			    });

 }



  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;

 openBuyTariffModal(tariffCode){
	if(!tariffCode) return;
	    this.popover.hide();

 this.dialogService.open(BuyTariffModalComponent, {
			       
			      context: { 
				tariffCode
			      },

					
			    // closeOnEsc: false,
				// closeOnBackdropClick: false
			    });

 }




openIdeaModal(){

 		this.dialogService.open(IdeaModalComponent, { });

}



  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

	if(this.menu$){
	this.menu$.unsubscribe()
	}




  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {

    this.sidebarService.toggle(  true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
   this.sidebarOpened = !this.sidebarOpened
    
              
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}
